import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'
import { lower } from 'change-case'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { StdCard, RowFields } from 'components'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { 
  typeOfBondOptions,
} from '../../AttributeData'
import { Cont } from './styled'

const GeneralInformation = (props) => {

  const { 
    valueForm,
    members, 
    memberLoading,
    vendorOptions, 
    companyOptions,
    customerOptions,
    change,
    // props
    isEdit = false,
    isDetail
  } = props

  React.useEffect(() => {
    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)
  }, [])

  const memberOptions = members.map((m,i) => ({ key:i, value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const getRequestForOption = () =>{
    let option = []
    if(valueForm.requestForType=='vendor') option = vendorOptions.data
    else option = customerOptions.data
    return option
  }

  return (
    <StdCard title={<span className='stepTitle'>General Information</span>}>
      <Cont>
        <RowFields>
          <Field 
            name="title"
            label="Title"
            component={FieldInput}
            type={type.text}
            editable={isEdit}
            require
          />
          <Field 
            name="requesterUser"
            label="Requester"
            component={FieldInput}
            loading={memberLoading}
            options={memberOptions}
            type={type.select}
            editable={isEdit}
            require
          />
        </RowFields>
        <RowFields>
          <Field 
            name="remark"
            label="Remark"
            component={FieldInput}
            type={type.textArea}
            editable={isEdit}
          />
        </RowFields>
        <RowFields>
          <Field 
            name='requestForCode' 
            label={valueForm.requestForType=='vendor'?'Vendor':'Customer'} 
            require
            options={getRequestForOption()} 
            loading={vendorOptions.loading} 
            editable={false}
            useLazyLoad
            type={type.select} 
            component={FieldInput} 
          />
          <Field 
            name='companyCode' 
            label='Company'
            require 
            options={companyOptions.data} 
            loading={companyOptions.loading}
            editable={false}
            type={type.select} 
            component={FieldInput} 
          />
        </RowFields>
        <RowFields>
          <Field 
            name="typeOfBond"
            label="Type of Bond"
            component={FieldInput}
            options={typeOfBondOptions}
            type={type.select}
            editable={false}
            className='halfRow'
            specialOnChange={(value)=>{
              if(value!='other'){
                //clear typeOfBondOther
                change('formBGCompany','typeOfBondOther','')
              }
            }}
            require
          />
          {valueForm.typeOfBond=='other'?
          <Field 
            name="typeOfBondOther"
            label="Other"
            component={FieldInput}
            type={type.text}
            editable={false}
            require
          />:null}
        </RowFields>
        <RowFields>
          <Field 
            name="amount"
            label="Amount"
            component={FieldInput}
            type={type.number}
            editable={isEdit&&valueForm.documentType=='Original'}
            className='halfRow'
            allowNegative={false}
            require
          />
        </RowFields>
      </Cont>
    </StdCard>
  )
}

const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formBGCompany')(state) || {},
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    vendorOptions: state.options.vendors,
    companyOptions: state.options.companies,
    customerOptions: state.options.customers,
  }
}

const mapDispatchToProps = {
  getHrmsMembers,
  change,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation)
